import { useTranslation } from 'react-i18next';
import { usePopup } from '../../../providers/PopupProvider';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { userService } from '../../../services/User/userService';
import { useError } from '../../../providers/useError';
import UpdateEmailForm from '../components/UpdateEmailForm';

export const useUpdateEmail = (onUpdated?: () => void) => {
  const { t } = useTranslation('users');
  const { showPopover, hidePopover, showConfirmPopover } = usePopup();
  const { errorMessage } = useError();

  const handleSave = (userId: number, email: string) => {
    if (!email) return;
    const onConfirm = () => {
      userService
        .updateEmail(userId, email)
        .then(() => {
          hidePopover();
          onUpdated?.();
        })
        .catch(error => errorMessage(error?.response?.data?.message));
    };
    showConfirmPopover(t('update-email-address.save-confirmation', { userId }), onConfirm);
  };

  const confirmEmail = (user: UserDetailsDto) => {
    const onConfirm = () => {
      userService
        .confirmEmail(user.id)
        .then(() => {
          hidePopover();
          onUpdated?.();
        })
        .catch(error => errorMessage(error?.response?.data?.message));
    };

    showConfirmPopover(t('update-email-address.verify-email', { userId: user.id }), onConfirm);
  };

  const showUpdateEmailPopover = (user: UserDetailsDto) => {
    showPopover(<UpdateEmailForm value={user.email} onConfirmPress={value => handleSave(user.id, value)} />);
  };

  return { showUpdateEmailPopover, confirmEmail };
};
